import { render, staticRenderFns } from "./DocumentCreateFromInvoiceModal.vue?vue&type=template&id=20b3ef4d&scoped=true&"
import script from "./DocumentCreateFromInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateFromInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3ef4d",
  null
  
)

export default component.exports